// SetupStore.js
import React from 'react';
import './SetupStore.css';

import productImg1 from './assets/product1.avif';
import productImg2 from './assets/product2.avif';
import productImg3 from './assets/product3.avif';
import productImg4 from './assets/product4.avif';
import productImg5 from './assets/product5.avif';
import productImg6 from './assets/product6.avif';
import productImg7 from './assets/product7.jpg';
// Import the arrow icon - you can use an SVG directly
import arrowIcon from './assets/arrow-icon.svg'; // You'll need to add this

const SetupStore = () => {
  return (
    <section className="text-center setup-store-section">

      <div className="flex justify-center">
        <span className="badge-sparkle">
          <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z" />
            <path d="M20 2v4" />
            <path d="M22 4h-4" />
            <circle cx="4" cy="20" r="2" />
          </svg>
          What We Offer
        </span>
      </div>

      <div className="container">
        <h2 className="section-title">
          Your Online Store<br></br> <span className="highlight">Set Up and Ready to Sell</span>
        </h2>
        <p className="section-subtitle">
          We turn your scattered DMs, WhatsApp orders and price questions into one branded e-commerce website that actually sells for you.
        </p>

        <div className="comparison-grid-wrapper">
          <div className="comparison-grid">
            {/* BEFORE - SCATTERED */}
            <div className="card before-card">
              <div className="card-header">
                <span className="badge before-badge">BEFORE - SCATTERED</span>
              </div>
              <div className="card-content">
                <div className="scattered-item instabox">
                  <div className="scattered-text">                    
                    <span className="platform">💬 Instagram DM</span>
                    <span className="message">"Price for this?"</span>
                  </div>
                </div>
                <div className="scattered-item randombox">
                  <div className="scattered-text">
                    <span className="platform">📲 WhatsApp Order</span>
                    <span className="message">"COD karwa do"</span>
                  </div>
                </div>
                <div className="scattered-item whatsappbox">
                  <div className="scattered-text">
                    <span className="platform">📷 Random product photos in gallery</span>
                  </div>
                </div>
                <div className="scattered-item stockbox">
                  <div className="scattered-text">
                    <span className="platform">💸 Manual price quoting</span>
                  </div>
                </div>
                <div className="scattered-item pricebox">
                  <div className="scattered-text">
                    <span className="platform">❓ "Stock available hai?"</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Purple Arrow in Middle */}
            <div className="arrow-container">
              <div className="purple-arrow-circle">
                <svg className="arrow-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M5 12h14"></path>
                  <path d="m12 5 7 7-7 7"></path>
                </svg>
              </div>
              <span className="arrroText">Commex sets it up</span>
            </div>

            {/* AFTER - ONE BRANDED STORE */}
            <div className="card after-card">

              <div className="card-header after-title-setup">
                <span className="badge after-badge">
                  AFTER · ONE BRANDED STORE
                </span>
              </div>

              <div className="store-window">

                <div className="browser-bar">
                  <div className="browser-left">
                    <span className="dot red"></span>
                    <span className="dot yellow"></span>
                    <span className="dot green"></span>
                  </div>

                  <span className="browser-url">
                    yourbrand.com
                  </span>
                </div>

                <div className="promo-banner">
                  NEW DROP • FREE DELIVERY
                </div>

                <div className="products-grid">

                  <div className="product-item">
                    <span className="tag new">NEW</span>
                    <img src={productImg1} alt="" />
                    <span className="price">PKR 4,890</span>
                  </div>

                  <div className="product-item">
                    <span className="tag hot">HOT</span>
                    <img src={productImg2} alt="" />
                    <span className="price">PKR 3,250</span>
                  </div>

                  <div className="product-item">
                    <img src={productImg3} alt="" />
                    <span className="price">PKR 2,890</span>
                  </div>

                  <div className="product-item">
                    <span className="tag sale">SALE</span>
                    <img src={productImg5} alt="" />
                    <span className="price">PKR 7,500</span>
                  </div>

                  <div className="product-item">
                    <img src={productImg6} alt="" />
                    <span className="price">PKR 1,290</span>
                  </div>

                  <div className="product-item">
                    <img src={productImg7} alt="" />
                    <span className="price">PKR 5,990</span>
                  </div>

                </div>

              </div>

              <div className="store-bottom">

                <div className="mini-card cart-card">
                  <div className="mini-title">
                    🛒 Cart · 2
                  </div>

                  <div className="mini-sub">
                    Total PKR 8,140
                  </div>
                </div>

                <div className="mini-card order-card">
                  <div className="mini-title">
                    ✓ Order #2384
                  </div>

                  <div className="mini-sub">
                    Confirmed · COD
                  </div>
                </div>

              </div>

              <div className="chat-strip">
                <span className="chat-icon">
                  🟢
                </span>

                <span>
                  "Available in size M?" — answered in chat
                </span>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SetupStore;